import React, { useCallback } from 'react';
import { Notification } from '../Notification';
import { AnimatedCloseIcon } from './AnimatedCloseIcon';
import { ToastRoot } from './components';
export var ToastItem = function ToastItem(_ref) {
  var action = _ref.action,
      _ref$inverted = _ref.inverted,
      inverted = _ref$inverted === void 0 ? false : _ref$inverted,
      _ref$dismissIn = _ref.dismissIn,
      dismissIn = _ref$dismissIn === void 0 ? 0 : _ref$dismissIn,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? false : _ref$icon,
      message = _ref.message,
      onClick = _ref.onClick,
      onDismiss = _ref.onDismiss,
      _ref$takeContainerWid = _ref.takeContainerWidth,
      takeContainerWidth = _ref$takeContainerWid === void 0 ? false : _ref$takeContainerWid,
      variant = _ref.variant;
  var defaultVariant = inverted ? 'black' : 'white';
  var onBodyClicked = useCallback(function () {
    onClick == null ? void 0 : onClick(onDismiss);
  }, [onClick, onDismiss]);
  var onActionClick = useCallback(function (handleClick) {
    return function () {
      handleClick(onDismiss);
    };
  }, [onDismiss]);
  return /*#__PURE__*/React.createElement(ToastRoot, {
    "data-test": "toast-" + variant,
    onClick: onBodyClicked,
    cursor: onClick && 'pointer',
    variant: variant,
    inverted: inverted,
    takeContainerWidth: takeContainerWidth
  }, icon && /*#__PURE__*/React.createElement(Notification.Icon, {
    "data-test": "toast-icon",
    variant: variant,
    icon: icon,
    alignSelf: "center"
  }), /*#__PURE__*/React.createElement(Notification.Content, null, /*#__PURE__*/React.createElement(Notification.Heading, {
    "data-test": "toast-message"
  }, message)), /*#__PURE__*/React.createElement(Notification.ButtonGroup, null, action ? /*#__PURE__*/React.createElement(Notification.Button, {
    onClick: onActionClick(action.onClick),
    variant: action.variant || defaultVariant,
    mode: action.mode,
    "data-test": "toast-action"
  }, action.children) : /*#__PURE__*/React.createElement(AnimatedCloseIcon, {
    onClick: onDismiss,
    dismissIn: dismissIn
  })));
};